import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

export default function(WrappedComponent, actionsOnMount = () => {}, mapStateToProps, mapDisptachToProps) {
    class ActiveOnMount extends Component {
        componentDidMount() {
            actionsOnMount(this.props);
        }

        render() {
            return <WrappedComponent {...this.props} />;
        }
    }

    return connect(mapStateToProps, mapDisptachToProps)(ActiveOnMount)
}


// WEBPACK FOOTER //
// ./src/components/shared/ActionOnMount.js